import { Gif } from '@giphy/react-components'
import { useQuery } from 'react-query'

import { getGifById } from 'services/endpoints/message'

import styles from '../../_message.module.scss'


const GifLoader = ({ id }: { id: number | string }) => {
    const { data, isLoading } = useQuery(
        ['gif', id],
        async () => await getGifById(id)
    )

    return (
        <div className={styles.gif_wrapper}>
            {!isLoading && data?.data ? (
                <Gif
                    gif={data.data}
                    width={186}
                    noLink
                    borderRadius={24}
                />
            ) : (
                <div className={styles.gif_placeholder}>
                    <div className={styles.gif_dots}>
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            )}
        </div>
    )
}

export default GifLoader